// TokenDeleter is responsible for showing a delete link
// next to a token when it is being edited.
export default class TokenDeleter {
  constructor($el, tokenRuler, query, input) {
    this.onChange = this.onChange.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.hideLink = this.hideLink.bind(this);
    this.$el = $el;
    this.tokenRuler = tokenRuler;
    this.query = query;
    this.input = input;
    this.$deleteLink = $('.token-delete');
  }

  bind() {
    this.$deleteLink.on('click', this.onClickDelete);
    this.query.on('change', this.onChange);
  }

  unbind() {
    this.$deleteLink.off('click', this.onClickDelete);
    this.query.off('change', this.onChange);
  }

  onChange() {
    const token = this.query.selectedToken;
    if (token && !token.isWhitespace() && !token.isPlaceholder()) {
      const dimensions = this.tokenRuler.dimensions(token.index);
      const inputPosition = this.$el.position();
      $('.token-delete').css({
        left: Math.max(
          5,
          Math.min(
            this.$el.width() - 10,
            dimensions.left + dimensions.width / 2 - 10,
          ),
        ),
        top: dimensions.height + inputPosition.top + 15,
      });
      $('.token-delete').show();
    } else {
      $('.token-delete').hide();
    }
  }

  onClickDelete(e) {
    e.preventDefault();
    e.stopPropagation();
    this.query.deleteTokenAtCursor(this.$el.prop('selectionEnd'));
  }

  hideLink() {
    $('.token-delete').hide();
  }
}
